import store from "../store";
document.addEventListener('visibilitychange', function (e) {
  if (document.visibilityState === 'visible') {
    // location.reload()
    if (localStorage.accessToken && localStorage.user) {
      store.commit("updateToken", localStorage.accessToken);
      store.commit("updateUser", JSON.parse(localStorage.user));
      store.commit("updateCartCount", localStorage.userCartCount);
    } else {
      store.commit("updateToken", '');
      store.commit("updateUser", {});
      store.commit("updateCartCount", 0);
    }
  } else {}
}, false);